export default __webpack_public_path__ + "static/media/arrowDown16.1a9e08d4.svg";